import { EventType } from 'hooks/useEventTracking';
import { MONITORING_COLLECTOR_TYPE } from 'utils/MonitorUtils';

export const getItemParamTracking = (event: React.MouseEvent<HTMLDivElement>, eventType: EventType) => {
  const currentEl = event.target as HTMLElement;

  let body: any = {};
  let eventKey = '';

  let screen = 'voucher-detail';

  if (currentEl.hasAttribute('track-button-cta')) {
    const disabled = currentEl.hasAttribute('disabled');

    if (disabled) return { body: {}, eventKey: "" };

    const dataRootTracking = currentEl.getAttribute('refer-data-root-voucher') || '';
    const trackingData = dataRootTracking.split(',');

    const rootDataEl = currentEl.closest('[data-root-voucher]') as HTMLElement;

    trackingData.forEach((key) => {
      const data = rootDataEl.getAttribute(`data-${key}`) || '';
      body[key] = data;
    });

    body = {
      ...body,
      screen,
      page: location.pathname,
    };

    if (eventType === 'onMouseMove') {
    }

    if (eventType == 'onClick') {
      eventKey = MONITORING_COLLECTOR_TYPE.CLICK_VOUCHER_DETAIL_CTA;
    }
  }

  if (currentEl.hasAttribute('track-input-search')) {

    const dataRootTracking = currentEl.getAttribute('refer-data-root-voucher') || '';
    const trackingData = dataRootTracking.split(',');

    const rootDataEl = currentEl.closest('[data-root-voucher]') as HTMLElement;

    trackingData.forEach((key) => {
      const data = rootDataEl.getAttribute(`data-${key}`) || '';
      body[key] = data;
    });

    body = {
      ...body,
      screen,
      page: location.pathname,
    };

    if (eventType === 'onMouseMove') {
    }

    if (eventType == 'onClick') {
      eventKey = MONITORING_COLLECTOR_TYPE.CLICK_VOUCHER_DETAIL_SEARCH;
    }
  }

  return { body, eventKey };
};

